// src/components/practices/shared/PracticeThankYouTap.js
// Controlled, presentational version of Journal.js's august-only consolidated "thank you"
// button (.stops-ty-single) — tap count, the mandatory reread-pause, and whether tapping is
// currently allowed are all owned by the parent flow component and passed in as props. This
// component only renders the current state and forwards taps via onTap.
import React from 'react'
import './PracticeThankYouTap.css'

export default function PracticeThankYouTap({ count, reread, canTap, onTap, writtenText }) {
  const done = count >= 3

  return (
    <div className="practice-ty-section" data-city="august">
      <p className="practice-ty-label">
        {count === 0 && 'Now say thank you — three times'}
        {count === 1 && 'Keep going…'}
        {count === 2 && 'One more…'}
        {count >= 3 && 'Beautiful. ✦'}
      </p>

      {/* Reread pause — resurfaces what was just written between taps, same reasoning as
          Journal.js's .stops-ty-reread: the button below is hard-disabled for the same window
          this card is visible, so fast tapping can't skip actually rereading it. */}
      {reread && writtenText && (
        <div className="practice-ty-reread">
          <span className="practice-ty-reread-label">What you wrote</span>
          <p className="practice-ty-reread-text">"{writtenText}"</p>
        </div>
      )}

      <button
        type="button"
        className={'practice-ty-single' + (done ? ' done' : '')}
        disabled={reread || done || !canTap}
        onClick={onTap}
      >
        {!done ? (
          <span className="practice-ty-single-icon" aria-hidden="true">✦</span>
        ) : (
          <svg className="practice-ty-ring" viewBox="0 0 24 24" width="24" height="24">
            <circle className="practice-ty-ring-track" cx="12" cy="12" r="10" fill="none" strokeWidth="2.2" />
            <path className="practice-ty-check" d="M5 13l4 4 10-11" fill="none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
        <span className="practice-ty-word">{!done ? '+ Add a thank you' : 'Thank you'}</span>
      </button>
    </div>
  )
}
